<template>
  <v-list-item-content>
    <div v-if="child" class="d-flex align-center justify-space-between">
      <div>
        {{ child.lastName }} {{ child.firstName }}
        <!-- {{ childAttendance(child.childId) }} -->
        <template v-if="childAttendance(child.childId)">
          <template v-if="childAttendance(child.childId).absence === 0">
            <template v-if="childAttendance(child.childId).status === 1">
              <v-chip color="primary" class="mx-2" outlined small>登園済み</v-chip>
            </template>
            <template v-if="childAttendance(child.childId).status === 2">
              <v-chip color="secondary" class="mx-2" outlined small>降園済み</v-chip>
            </template>
          </template>
          <template v-if="childAttendance(child.childId).absence === 1">
            <v-chip color="grey" class="mx-2" outlined small>おやすみ</v-chip>
          </template>
          <template v-if="childAttendance(child.childId).pickup">
            <template
              v-if="
                childAttendance(child.childId).pickup.pickup.by ||
                  childAttendance(child.childId).pickup.dropOff.by
              "
            >
              <v-chip color="orange" class="mx-2" outlined small>送迎変更</v-chip>
            </template>
          </template>
        </template>
      </div>

      <div class="d-flex">
        <template v-if="childChatSummary.comment">
            <v-icon color="#E190CF">mdi-note-outline</v-icon>
        </template>
        <template v-if="childChatSummary.chatUnreadCount > 0">
        <v-chip color="primary" class="mx-2 pa-2" small>{{ childChatSummary.chatUnreadCount }}</v-chip>
        </template>
        <v-icon>mdi-chevron-right</v-icon>
      </div>
    </div>
  </v-list-item-content>
</template>
<script lang="ts">
import Vue, { PropType, defineComponent } from 'vue';

import { NurseryChildResponse } from 'chaild-api/lib/index';
import { GetAttendanceSearchResponse } from '@/model/Response';

import LocalDataService from '@/service/LocalDataService';
import dayjs from 'dayjs';
import { chatModule } from '@/store/dataModules/chatModule';

import { ChatSummaryResponse } from 'chaild-api/lib/index';

export default defineComponent({
  data: () => {
    return {};
  },
  props: {
    child: {
      type: Object as PropType<NurseryChildResponse>,
      required: true,
    },
    attendanceClass: {
      type: Object as PropType<GetAttendanceSearchResponse>,
      required: true,
    },
    chatSummary: {
      type: Object as PropType<any>,
    },
  },
  computed: {
    childChatSummary() {
      const find = this.chatSummary.childrenAttendance.find(
        childAttendance => childAttendance.child.childId === this.child.childId
      );
      if (find) {
        return find;
      } 
      return null
    },
  },
  methods: {
    childAttendance(childId?: number) {
      if (childId) {
        const find = this.attendanceClass.attendances.find(
          attendance => attendance.child.childId === childId
        );
        return find;
      }
    },
  },
  async mounted() {},
});
</script>
<style lang="scss" scoped></style>
